import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import { PCTableOutputModel } from '../../models/pc-table-input-model';

@Component({
  selector: 'app-user-account-setting',
  templateUrl: './user-account-setting.component.html',
  styleUrl: './user-account-setting.component.css'
})

export class UserAccountSettingComponent implements AfterViewInit {
  constructor(
    public logger: LoggerService,
    private apiService: UserApiService,
  ) { }

  public submitted: boolean = false;
  public loading: boolean = false;
  public oldPassword: string = '';
  public newPassword: string = '';
  public confirmPassword: string = '';
  public modalSuccessConfirm: boolean = false;

  ngAfterViewInit() {
    console.log(this.oldPasswordInput);
  }

  @ViewChild('oldPasswordInput') oldPasswordInput!: ElementRef;
  @ViewChild('newPasswordInput') newPasswordInput!: ElementRef;
  @ViewChild('confirmPasswordInput') confirmPasswordInput!: ElementRef;

  public parentSearchAction(event: PCTableOutputModel) {
    try {
      switch (event.action) {
        case 'Successed':
          this.modalSuccessConfirm = false;
          break;
        default:
          break;
      }
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }
  
  public onSubmit() {

  if (!this.oldPasswordInput || !this.newPasswordInput || !this.confirmPasswordInput) {
    alert('خطایی رخ داده است. لطفاً دوباره تلاش کنید.');
    return;
  }
  const oldPassword = this.oldPasswordInput.nativeElement.value;
  const newPassword = this.newPasswordInput.nativeElement.value;
  const confirmPassword = this.confirmPasswordInput.nativeElement.value;

  if (!oldPassword || !newPassword || !confirmPassword) {
    this.logger.addError(`لطفاً تمام فیلدها را پر کنید` , false);
    return;
  }

  if (newPassword !== confirmPassword) {
    this.logger.addError(`رمز عبور جدید و تکرار آن یکسان نیستند. ` , false);
    return;
  }
  this.changePassword();
}

  public passwordsMatch(): boolean {
  const newPassword = this.newPasswordInput.nativeElement.value;
  const confirmPassword = this.confirmPasswordInput.nativeElement.value;
  return newPassword === confirmPassword;
}

  public changePassword() {
  try {
    this.loading = true;
    let url = `User/ChangeMySelfPassword`;
    let backendJson = {
      oldPassword: this.oldPasswordInput.nativeElement.value,
      newPassword: this.newPasswordInput.nativeElement.value,
    };

    if (!this.apiService.tokenValidation(new ApiRequestModel(url, backendJson))) {
      return;
    }

    this.apiService.patchItem(new ApiRequestModel(url, backendJson)).subscribe(
      (result) => {
        this.logger.addResponseLog(url, result, `Change Password`);
        if (result.succeeded) {
          this.modalSuccessConfirm = true;
          this.loading = false;
        } else {
          this.logger.addBackEndMessage(result);
        }
        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  } catch (e) {
    this.logger.addException(e, true);
    this.loading = false;
  }
}


}
